import React from 'react';
import type { CSSProperties } from 'react';

const nodeCard: CSSProperties = {
  flex: 1,
  borderRadius: 10,
  padding: 12,
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  background: '#0a1628',
  border: '1px solid #1e3a5f',
};

const iconBox = (bg: string, size = 30, radius = 8): CSSProperties => ({
  width: size,
  height: size,
  borderRadius: radius,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  flexShrink: 0,
  background: bg,
});

const bar = (borderColor: string, color: string, bg: string): CSSProperties => ({
  borderRadius: 10,
  border: `1.5px solid ${borderColor}`,
  textAlign: 'center',
  fontWeight: 800,
  fontSize: '0.78rem',
  letterSpacing: '0.04em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  color,
  background: bg,
  padding: 9,
});

const HmfIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M3 10h18M9 4v6M15 10v6M3 16h18M6 10v6" />
  </svg>
);
const ZtaIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);
const AiIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" />
  </svg>
);
const SplunkIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12h4l2-6 4 12 2-6h6" />
  </svg>
);

export default function SecurityPlatformDiagram() {
  return (
    <div style={{ background: '#0d1b2a', border: '1px solid #1e3a5f', borderRadius: 16, overflow: 'hidden' }}>
      <div style={{ padding: '14px 18px', borderBottom: '1px solid #1e3a5f', display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'linear-gradient(90deg, #16bdeb, #3070e7)', boxShadow: '0 0 10px rgba(22,189,235,0.7)' }} />
        <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#e0e7ef', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
          Cisco Security Platform
        </span>
      </div>

      <div style={{ padding: 14 }}>
        {/* Cisco Cloud Control wraps Identity, Data Fabric (Splunk), and the solution grid */}
        <div style={{ border: '1.5px solid #5b6d8c', borderRadius: 14, padding: 14, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ textAlign: 'center', fontWeight: 800, fontSize: '0.78rem', letterSpacing: '0.04em', color: '#cdd8e8' }}>
            Cisco Cloud Control
          </div>

          <div style={bar('#16bdeb', '#7fdcf5', 'rgba(22,189,235,0.08)')}>Identity</div>

          <div style={bar('#049fd9', '#6cd2f2', 'rgba(4,159,217,0.1)')}>
            <span style={iconBox('linear-gradient(135deg, #049fd9, #16bdeb)', 22, 6)}><SplunkIcon /></span>
            Data Fabric (Splunk)
          </div>

          <div style={{ border: '1.5px solid #16bdeb44', borderRadius: 12, padding: 12, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={nodeCard}>
                  <span style={iconBox('linear-gradient(135deg, #c2185b, #e04f7b)')}><HmfIcon /></span>
                  <div style={{ fontWeight: 800, fontSize: '0.8rem', color: '#e0e7ef' }}>Hybrid Mesh Firewall</div>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={nodeCard}>
                  <span style={iconBox('linear-gradient(135deg, #0277bd, #16bdeb)')}><ZtaIcon /></span>
                  <div style={{ fontWeight: 800, fontSize: '0.8rem', color: '#e0e7ef' }}>Zero Trust Architecture (SASE)</div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '50%' }}>
                <div style={{ ...nodeCard, width: '100%' }}>
                  <span style={iconBox('linear-gradient(135deg, #e65100, #ff9000)')}><AiIcon /></span>
                  <div style={{ fontWeight: 800, fontSize: '0.8rem', color: '#e0e7ef' }}>AI Security</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
